import {billingStore, useWBAgentBillingAccess} from './billing';

/** ReadonlyInputs are the signals that determine whether the chat is locked. */
type ReadonlyInputs = {
  accessible: boolean;
};

/**
 * computeAgentChatReadonly derives whether the chat is locked for writes from
 * its inputs. Billing access is the only input today; other lock reasons join
 * here so every gate updates together.
 */
export function computeAgentChatReadonly(inputs: ReadonlyInputs): boolean {
  return !inputs.accessible;
}

/**
 * useAgentChatReadonly reports whether the chat is locked, so modifying actions
 * must be blocked and the UI shown as disabled. React counterpart of
 * isAgentChatReadonly.
 */
export function useAgentChatReadonly(): boolean {
  return computeAgentChatReadonly({
    accessible: useWBAgentBillingAccess().accessible,
  });
}

/**
 * isAgentChatReadonly reads the current lock state for non-React callers, so
 * imperative writers gate on readonly instead of on billing access directly.
 */
export function isAgentChatReadonly(): boolean {
  return computeAgentChatReadonly({accessible: billingStore.isAccessible()});
}
